__turbopack_context__.v({
  "container": "SelectField-module__AW7xIG__container",
  "fadeInItems": "SelectField-module__AW7xIG__fadeInItems",
  "hasError": "SelectField-module__AW7xIG__hasError",
  "hasLabel": "SelectField-module__AW7xIG__hasLabel",
  "hasOptionsDisplayer": "SelectField-module__AW7xIG__hasOptionsDisplayer",
  "hasValue": "SelectField-module__AW7xIG__hasValue",
  "input": "SelectField-module__AW7xIG__input",
  "inputContainer": "SelectField-module__AW7xIG__inputContainer",
  "label": "SelectField-module__AW7xIG__label",
  "option": "SelectField-module__AW7xIG__option",
  "optionDisabled": "SelectField-module__AW7xIG__optionDisabled",
  "optionSelected": "SelectField-module__AW7xIG__optionSelected",
  "options": "SelectField-module__AW7xIG__options",
  "spacing--lg": "SelectField-module__AW7xIG__spacing--lg",
  "spacing--md": "SelectField-module__AW7xIG__spacing--md",
  "spacing--sm": "SelectField-module__AW7xIG__spacing--sm",
  "spacing--xl": "SelectField-module__AW7xIG__spacing--xl",
  "spacing--xs": "SelectField-module__AW7xIG__spacing--xs",
  "spacing--xxl": "SelectField-module__AW7xIG__spacing--xxl",
  "spacing--xxs": "SelectField-module__AW7xIG__spacing--xxs",
  "spacing--xxxl": "SelectField-module__AW7xIG__spacing--xxxl",
  "spacing--xxxs": "SelectField-module__AW7xIG__spacing--xxxs",
  "subOption": "SelectField-module__AW7xIG__subOption",
});
